import { useTheme, useMediaQuery } from '@mui/material';

/**
 * Custom hook to provide responsive breakpoints across the app
 * - isMobile: screen width <= small (600px)
 * - isTablet: screen width <= large (1200px) - EXTENDED for better UX
 * - isLargeScreen: screen width >= extra large (1536px) - STRICTER
 * 
 * This ensures the drawer/sidebar is shown earlier to prevent cramped AppBar
 */
export default function useResponsive() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // <= 600px
  const isTablet = useMediaQuery(theme.breakpoints.down('lg')); // <= 1200px (was 'md' 900px)
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('xl')); // >= 1536px (was 'lg' 1200px)
  return { isMobile, isTablet, isLargeScreen };
}
